import { montserratBold, montserratMedium, montserratNormal } from '@/assets/fonts/montserrat'
import React, { useEffect, useRef } from 'react'
import { idPrivacy } from '@/helpers/content/id/privacy'
import { useState } from 'react'
import { enPrivacyContent } from '@/helpers/content/en/privacy'
export default function PrivacyPolicy({lang = "id"}) {
  const contentRef = useRef([])
  const [content, setContent] = useState(null)
  const [indexDefault, setIndexDefault] = useState(0)
  useEffect(() => {
    if (lang == "id") {
        setContent(idPrivacy)
    }else{
        setContent(enPrivacyContent)
    }
  }, [lang])

  const handleGoToContent = (index) => {
    contentRef.current[index].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
    })
    setIndexDefault(index)
  }
  
  return (
    <div className='flex relative flex-col w-full h-full'>
        <div className='flex overflow-hidden relative justify-center items-center py-56 bg-blue-primary-600'>
            <div className='absolute bg-[#FF9FA0] w-[500px] right-[60%] flex justify-center h-[500px] rounded-full opacity-100 blur-[250px] skew-y-[20deg]'>
            </div>
            <div className='absolute bg-[#7BD2FE] right-[30%] -top-[30%] blur-[220px] flex justify-center w-[500px] h-[500px] rounded-full opacity-100 skew-y-[20deg]'>
            </div>
            <div className='absolute bg-[#7BD2FE] blur-[220px] right-0 flex justify-center w-[500px] h-[500px] rounded-full opacity-100 skew-y-[20deg]'>
            </div>
            <h1 className={`${montserratBold.className} text-[35px] text-base-white z-40`}>{lang == "id" ? "Kebijakan Privasi" : "Privacy Policy"}</h1>
        </div>
        <div className='flex lg:px-8 py-20 flex-row w-full'>
            <div className='hidden lg:flex flex-col h-fit w-1/4'>
                {
                    content?.data.map((val,index) => (
                        <p key={index} onClick={() => handleGoToContent(index)} className={`flex hover:cursor-pointer hover:bg-gray-cool-100 w-fit mb-4 rounded-lg p-4 ${index == indexDefault ? "justify-center items-center bg-gray-cool-100" : ""} ${montserratNormal.className} text-base-black`}>{val.title}</p>
                    ))
                }
            </div>
            <div className='flex px-4 lg:pl-12 w-[100%] flex-col'>
                <div className={`${montserratNormal.className} flex pb-16`}>{content?.main}</div>
                {
                    content?.data.map((val,index) => (
                        <div ref={(el) => contentRef.current.push(el)} className={`flex flex-col ${index != 0 ? "pt-16" : ""}`}>
                            <p className={`${montserratBold.className}`}>{val.title}</p>
                            <p className={val.text ? `pt-3 ${montserratNormal.className}` : ""}>{val.text}</p>
                            <p className={val.text2 ? `pt-3 ${montserratNormal.className}` : ""}>{val.text2}</p>
                            <ol className={`${val.list.length > 0 ? "p-8" : ""} flex flex-col space-y-6 list-disc`}>
                                {
                                    val.list.map((list) => (
                                        <li className={`${montserratNormal.className}`}>{list.desc}</li>
                                    ))
                                }
                            </ol>
                        </div>
                    ))
                }
                <div className='grid grid-flow-row w-1/2 gap-3 py-8 grid-cols-3'>
                    <div className={`${montserratNormal.className}`}>{lang == "id" ? "Email" : "Email"}</div>
                    <div className='col-span-2 flex'>: <p className={`pl-2 ${montserratMedium.className}`}>{content?.contact.email}</p></div>
                    <div className={`${montserratNormal.className}`}>{lang == "id" ? "Telp" : "Phone"}</div>
                    <div className='col-span-2 flex'>: <p className={`pl-2 ${montserratMedium.className}`}>{content?.contact.phone}</p></div>
                    <div className={`${montserratNormal.className}`}>{lang == "id" ? "Alamat" : "Address"}</div>
                    <div className='col-span-2 w-[45vh] md:w-[100vh] lg:w-fit flex'>: <p className={`pl-2 ${montserratMedium.className}`}>{content?.contact.address}</p></div>
                </div>
            </div>
        </div>
    </div>
  )
}
